<template>
  <v-container id="license" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card color="primary">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">{{ $t("license") }}</div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="licenseItem.type"
                    :label="$t('type')"
                    disabled
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="licenseItem.channel_limit"
                    :label="$t('channel') + ' ' + $t('limit').toLowerCase()"
                    disabled
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="expireTime"
                    :label="$t('expire') + ' ' + $t('time').toLowerCase()"
                    disabled
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" v-if="false">
                  <v-text-field
                    v-model="licenseData.key"
                    :label="$t('license') + ' ' + $t('key')"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" v-if="false" class="text-right">
                  <v-btn color="primary" class="mr-0">
                    {{ $t("update") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getLicense } from "@/endpoint/license";
import { translateTime } from "@/plugins/util";

export default {
  name: "License",

  data() {
    return {
      licenseData: {
        key: "touchcloud-developLicenseKey",
      },
      licenseItem: {
        key: null,
        type: null,
        channel_limit: 0,
        expire_time: null,
      },
    };
  },
  created() {
    this.init(this);
  },
  computed: {
    expireTime() {
      if (this.licenseItem.expireTime == null) {
        return "Unlimit";
      }
      return this.translateTime(this.licenseItem.expire_time);
    },
  },
  methods: {
    translateTime: translateTime,
    async init(scope) {
      scope.licenseItem = await getLicense();

      return scope;
    },
  },
};
</script>
